module.exports = __webpack_public_path__ + "img/namibia-logo-icon.1e101591.png";